// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__Q8nhq","navbar_list":"Navbar_navbar_list__hb8CD","navbar__li":"Navbar_navbar__li__Bfucp","navbar__item":"Navbar_navbar__item__6Rjp1"};